import CustomizableGeneric from './CustomizableGeneric';

class ItemList extends CustomizableGeneric {
  getTypeName = () => 'ItemList';

  getFields = () => ['numberOfItems', 'url', 'itemListElement'];
}

export default ItemList;
